module.exports = __webpack_public_path__ + "img/program3.752cf10a.svg";